import {Routes} from '@angular/router';
import {PhoneLoginComponent} from './phone-login/phone-login.component';
import {PinEntryComponent} from './pin-entry/pin-entry.component';
import {OtpEntryComponent} from './otp-entry/otp-entry.component';
import {PinCreateComponent} from "./pin-create/pin-create.component";

export const phoneLoginRoutes: Routes = [
  {
    path: '',
    redirectTo: '/result/page-not-found',
    pathMatch: 'full'
  },
  {
    path: 'phone-login/:trackingId',
    component: PhoneLoginComponent
  },
  {
    path: 'pin-entry/:trackingId',
    component: PinEntryComponent
  },
  {
    path: 'otp-entry/:trackingId',
    component: OtpEntryComponent
  },
  {
    path: 'pin-create/:trackingId',
    component: PinCreateComponent
  },
  {
    path: '**',
    redirectTo: '/result/page-not-found',
    pathMatch: 'full'
  }
];
